import { Component } from '@angular/core';
import { AlertController, App, MenuController, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { LoginControl } from '../providers/helpers/login';
import { LoginPage } from '../pages/login/login';
import { ProfilePage } from '../pages/profile/profile';
import { UsersPage } from '../pages/users/users';
import { TurmasPage } from '../pages/turmas/turmas';
import { CuponsPage } from '../pages/cupons/cupons';
import { AlunosPage } from '../pages/alunos/alunos';
import { MatriculasPage } from '../pages/matriculas/matriculas';
import { DataPagamentoPage } from '../pages/data-pagamento/data-pagamento';
import { CobrancasPage } from '../pages/cobrancas/cobrancas';
import { ReportFinancialPage } from '../pages/report-financial/report-financial';
import { CobrancasArquivadasPage } from '../pages/cobrancas-arquivadas/cobrancas-arquivadas';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  rootPage: any = null;
  pages = new Array();

  constructor(
    platform: Platform, statusBar: StatusBar,
    splashScreen: SplashScreen, private loginCtrl: LoginControl,
    private app: App, private menuCtrl: MenuController,
    private alertCtrl: AlertController) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      this.setRootPage();
      this.setMenus();
    });
  }

  /**
   * Defina a página principal
   */
  private setRootPage() {
    if (this.loginCtrl.userLogged() == false) {
      this.menuCtrl.close('menu-principal');
      this.menuCtrl.enable(false, "menu-principal");
      this.rootPage = LoginPage;
    } else {
      this.menuCtrl.enable(true,"menu-principal");
      this.rootPage = HomePage;
    }
  }

  public openPage(page: any) {
    if (page.component == null) {
      return false;
    }
    this.menuCtrl.close('menu-principal');
    this.menuCtrl.enable(false, "menu-principal");
    this.app.getActiveNavs()[0].push(page.component, page.params);
  }

  public logout() {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo sair?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.loginCtrl.clearAll();
            this.menuCtrl.close('menu-principal');
            this.menuCtrl.enable(false, "menu-principal");
            this.app.getActiveNavs()[0].setRoot(LoginPage);
            this.app.getActiveNavs()[0].popToRoot();
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Define os menus
   */
  private setMenus() {
    this.pages.push(
      {
        title: "Meu Perfil",
        icon: "ios-person",
        component: ProfilePage,
        params: {}
      },
      {
        title: "Gestor de Usuários",
        icon: "ios-people",
        component: UsersPage,
        params: {}
      },
      {
        title: "Gestor de Alunos",
        component: AlunosPage,
        icon: "ios-school",
        params: {}
      },
      {
        title: 'Gestor de Matrículas',
        component: MatriculasPage,
        icon: "ios-ribbon",
        params: {}
      },
      {
        title: 'Gestor de Cobranças',
        component: CobrancasPage,
        icon: "logo-usd",
        params: {}
      },
      {
        title: 'Gestor de Turmas',
        component: TurmasPage,
        icon: "ios-book",
        params: {}
      },
      {
        title: "Gestor de Cupons",
        component: CuponsPage,
        icon: "md-pricetag",
        params: {}
      },
      {
        title: "Dados de Pagamento",
        component: DataPagamentoPage,
        icon: "md-cog",
        params: {}
      },
      {
        title: "Relatório Financeiro",
        component: ReportFinancialPage,
        icon: "md-clipboard",
        params: {}
      },
      {
        title: 'Cobranças Arquivadas',
        component: CobrancasArquivadasPage,
        icon: "logo-usd",
        params: {}
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts